import { instance } from '@/libs/api/instance'

export const updateNotifications = async (data) => {
  return instance.patch('/v1/notification', data)
}
